.hero {
  text-align: center;
  padding: 48px 24px 24px;
}

.title {
  font-size: 44px;
  font-weight: 800;
  letter-spacing: -0.04em;
  margin: 0 0 14px;
  background: linear-gradient(
    135deg,
    var(--ps-text-primary) 0%,
    var(--ps-gold) 50%,
    var(--ps-green) 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

@media (max-width: 768px) {
  .title {
    font-size: 32px;
  }
}
